export { default as TableHeadRow } from "./table-head-row";
